import { API, Auth } from 'aws-amplify';
import awsmobile from '../aws-exports'; // eslint-disable-line import/no-unresolved

const HEADERS = {
  AUTHORIZATION: 'authorization',
  X_USER_POOL_ID: 'x-user-pool-id',
  X_APP_CLIENT_ID: 'x-app-client-id',
};

export const amplifyApi = async (body, endpoint, type, response = false) => {
  const apiName = 'clarityCore';
  const path = endpoint;
  const init = {
    body,
    headers: {
      [HEADERS.X_USER_POOL_ID]: awsmobile.aws_user_pools_id,
      [HEADERS.X_APP_CLIENT_ID]: awsmobile.aws_user_pools_web_client_id,
      [HEADERS.AUTHORIZATION]: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`,
    },
    response, // return the entire Axios response object instead of only response.data
  };

  return await API[type](apiName, path, init);
};
